module.exports = __webpack_public_path__ + "images/index/img07.b69d58c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/chenmei/img07.jpg
// module id = 7XLr
// module chunks = 21